export default "__VITE_ASSET__UC1LISOJ__"